import { Logs } from "./module/logs";

class Store {
  /** 埋点信息 */
  Logs = new Logs();
}

/** mobx存储器 */
export const store = new Store();